<template>
  <div class="anchor-id">
    <div class="text-right mb-20">
      <el-button size="mini" type="primary" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-props="{ 'max-height': '450px' }"
      :table-key="table_key"
      :table-list-data="tableData"
    />
  </div>
</template>

<script>
import { getByteDanceGameApi, pullByteDanceGameApi } from '@/api/tool/byte-dance-game';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
    // 当前广告主ID
    advertiserId: {
      type: String,
      required: true,
    },
    // 渠道号
    channelAlias: {
      type: Array,
      required: true,
    },
    // 表格数据
    tableData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // 表头配置
      table_key: require('./model/table-key.js')(this),
    };
  },
  computed: {
    // 渠道接口
    channel_interface() {
      const { channel_interface } = this.initOps;
      return channel_interface;
    },
    // 字节小游戏配置
    micro_app_config() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { delivery_content_id } = delivery_form.config;
      const delivery_content = delivery_content_id.value.result_map[this.advertiserId];
      const { jrtt_params: { micro_app_id, micro_app_instance_id } = {}} = delivery_content.options.find(({ value }) => delivery_content.value === value);
      return { micro_app_id, micro_app_instance_id };
    },
  },
  created() {
    if (this.formItem.value.result_value.length) {
      this.edit();
    } else {
      this.generateTableData();
    }
  },
  methods: {
    /**
     * 生成表格数据
     */
    async generateTableData() {
      const options = await this.getByteDanceGameList();
      const data = this.channelAlias.map(({ alias }) => {
        return {
          advertiser_id: this.advertiserId,
          channel_alias: alias,
          target: { ...this.initTarget(options) },
        };
      });
      this.tableData.push(...data);
    },
    /**
     * 编辑
     */
    edit() {
      const data = this.formItem.value.result_value.filter(({ advertiser_id }) => advertiser_id === this.advertiserId)
        .map(({ advertiser_id, channel_alias, options, value }) => {
          return {
            advertiser_id,
            channel_alias,
            target: { ...this.initTarget(options, value) },
          };
        });
      this.tableData.push(...data);
    },
    /**
     * 初始化目标
     * @returns {Object}
     */
    initTarget(init_options = [], init_value = '') {
      return {
        options: init_options,
        value: init_value,
      };
    },
    /**
     * 获取字节小游戏列表
     * @returns {Promise<Object[]>}
     */
    getByteDanceGameList() {
      return new Promise((resolve, reject) => {
        getByteDanceGameApi({
          filtering: {
            micro_app_instance_id: this.micro_app_config.micro_app_instance_id,
          },
          advertiser_id: this.advertiserId,
          channel_interface: this.channel_interface,
        }).then(({ list = [] }) => {
          const result = list.map(({ id, name, url }) => ({ label: name, value: `${id}#${url}` }));
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 同步
     */
    async onPull() {
      const { message } = await pullByteDanceGameApi({
        filtering: {
          micro_app_instance_id: this.micro_app_config.micro_app_instance_id,
        },
        advertiser_id: this.advertiserId,
        channel_interface: this.channel_interface,
      });
      const result = await this.getByteDanceGameList();
      this.tableData.forEach(({ target }) => {
        target.options = result;
      });
      this.$message.success(message || '同步成功');
    },
  },
};
</script>

<style lang="scss" scoped>
.anchor-id {
  padding: 20px;
}
</style>
